import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async processFranchiseNotifications({ commit }) {
      try {
        return await api.get('/chrons/franchise-notifications')
      } catch (error) {
        throw error
      }
    },

    async getFranchiseNotificationClients({ commit }) {
      try {
        const response = await api.get('/franchise-notifications/clients')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getFranchiseNotificationClient({ commit }, clienteId) {
      try {
        const response = await api.get(
          `/franchise-notifications/clients/${clienteId}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getFranchiseNotificationClientFranchise({ commit }, clienteId) {
      try {
        const response = await api.get(
          `/franchise-notifications/clients/${clienteId}/franchise`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateFranchiseNotificationClient({ commit }, data) {
      try {
        return await api.put(
          `/franchise-notifications/clients/${data.clienteId}`,
          { percentuais: data.percentuais },
        )
      } catch (error) {
        throw error
      }
    },

    async updateFranchiseNotificationContact({ commit }, data) {
      try {
        return await api.put(
          `/franchise-notifications/clients/${data.clienteId}/contacts/${data.contatoId}`,
          { recebeNotificacaoFranquia: data.recebeNotificacaoFranquia },
        )
      } catch (error) {
        throw error
      }
    },

    async getFranchiseNotificationHistory({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/franchise-notifications/history?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
